export default __webpack_public_path__ + "static/media/24.d9a08635.svg";